"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var getViewFilterDisplay_1 = require("../helpers/getViewFilterDisplay");
var Icon_1 = require("office-ui-fabric-react/lib/Icon");
var mobx_react_1 = require("mobx-react");
var owa_mail_filter_actions_1 = require("owa-mail-filter-actions");
var owa_mail_focus_manager_1 = require("owa-mail-focus-manager");
var KeyboardCharCodes_1 = require("owa-mail-hotkeys/lib/utils/KeyboardCharCodes");
var owa_mail_list_filter_view_1 = require("owa-mail-list-filter-view");
var owa_mail_list_store_1 = require("owa-mail-list-store");
var owa_mail_strings_1 = require("owa-strings/owa-mail-strings");
var React = require("react");
var owa_mail_list_filter_store_1 = require("owa-mail-list-filter-store");
var owa_accessibility_1 = require("owa-accessibility");
var classNames = require('classnames/bind');
var styles = require('./MailListFilter.scss');
var MailListFilter = /** @class */ (function (_super) {
    tslib_1.__extends(MailListFilter, _super);
    function MailListFilter(props) {
        var _this = _super.call(this, props) || this;
        _this.onFilterClick = function (evt) {
            evt.stopPropagation();
            _this.onSelectFilter();
        };
        /**
         * Called when user presses keyboard on the filter dropdown title in listview
         */
        _this.onKeyDownOnFilter = function (ev) {
            switch (ev.keyCode) {
                case KeyboardCharCodes_1.ENTER_CHARCODE:
                case KeyboardCharCodes_1.SPACE_CHARCODE:
                    ev.stopPropagation();
                    ev.preventDefault();
                    _this.onSelectFilter();
                    break;
            }
        };
        return _this;
    }
    MailListFilter.prototype.onSelectFilter = function () {
        if (owa_mail_list_store_1.getViewFilterForTable(owa_mail_list_store_1.getSelectedTableView()) == 'All') {
            owa_mail_list_filter_store_1.showFilterDropDownContextMenu();
        }
        else {
            // Dismiss the filter if the LV is already filtered
            owa_mail_filter_actions_1.selectFilter('All', this.props.filterMenuSource);
            // Reset focus when the filter is closing and changing to "All"
            owa_mail_focus_manager_1.resetFocus();
        }
    };
    MailListFilter.prototype.dismissContextMenu = function () {
        owa_mail_list_filter_store_1.hideFilterDropDownContextMenu();
        // Reset focus when filter context menu is dismissed
        owa_mail_focus_manager_1.resetFocus();
    };
    MailListFilter.prototype.getSelectedFilterText = function (currentSelectedFilter) {
        if (currentSelectedFilter == 'All') {
            return owa_mail_strings_1.default.mailFilter;
        }
        return getViewFilterDisplay_1.default(currentSelectedFilter);
    };
    MailListFilter.prototype.render = function () {
        var _this = this;
        var currentSelectedFilter = owa_mail_list_store_1.getViewFilterForTable(owa_mail_list_store_1.listViewStore.tableViews.get(this.props.tableViewId));
        var isAllFilterSelected = currentSelectedFilter == 'All';
        var containerClassNames = classNames(this.props.containerClassName, styles.filter);
        var dropDownIconClassNames = classNames(styles.icon, !isAllFilterSelected && styles.cancelIcon);
        var ariaProps = {
            role: owa_accessibility_1.AriaRoles.button,
        };
        return (React.createElement("div", tslib_1.__assign({ ref: function (ref) { return (_this.container = ref); }, className: containerClassNames, onClick: this.onFilterClick, onKeyDown: this.onKeyDownOnFilter }, owa_accessibility_1.generateDomPropertiesForAria(ariaProps), { tabIndex: 0 }),
            React.createElement("span", { className: styles.filterText }, this.getSelectedFilterText(currentSelectedFilter)),
            React.createElement(Icon_1.Icon, { className: dropDownIconClassNames, iconName: isAllFilterSelected ? "ChevronDownMed" /* ChevronDownMed */ : "Cancel" /* Cancel */ }),
            owa_mail_list_filter_store_1.filterViewStore.filterContextMenuDisplayState && (React.createElement(owa_mail_list_filter_view_1.MailFilterContextMenu, { currentViewFilter: currentSelectedFilter, supportedViewFilters: this.props.supportedViewFilters, dismissContextMenu: this.dismissContextMenu, contextMenuTargetElement: this.container, filterMenuSource: this.props.filterMenuSource, tableViewId: this.props.tableViewId }))));
    };
    MailListFilter = tslib_1.__decorate([
        mobx_react_1.observer
    ], MailListFilter);
    return MailListFilter;
}(React.Component));
exports.default = MailListFilter;
//# sourceMappingURL=MailListFilter.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/mail/view/owa-mail-list-filter-view/lib/components/MailListFilter.js
// module id = 2322
// module chunks = 46 105